import React, { PureComponent } from "react";
import SidebarComponent from "./SidebarComponent";
import PropTypes from "prop-types";

class SidebarContainer extends PureComponent {
  static propTypes = {
    content: PropTypes.object.isRequired
  };

  render() {
    const { content, withMask } = this.props;

    return <SidebarComponent content={content} withMask={withMask} />;
  }
}

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarContainer.js